import * as classnames from "classnames";

import { JumpTo, CliSupportBadge, Msg } from "@shared/components";
import { ApplicantExamModel } from "@shared/models";
import * as ExamService from "@shared/services/exam";
import Message from "@shared/services/message";

/**
 * Prop interface
 */
export interface HelpSectionProps {
  exam: ApplicantExamModel;
  tutorial?: boolean;
  sticky?: boolean;
}

/**
 * Page component
 */
export function HelpSection({ exam, tutorial, sticky }: HelpSectionProps) {
  const hasQuizChallenge = ExamService.hasQuizChallenge(exam);
  const hasCodingChallenge = ExamService.hasCodingChallenge(exam);
  const hasAIChallenge = ExamService.hasAIChallenge(exam);
  const hasCLIChallenge = ExamService.hasCLIChallenge(exam);
  const rootStyle = classnames("code-editor-help", { sticky });

  return (
    <div className={rootStyle}>
      <div className="code-editor-help-section">
        <p className="code-editor-help-section-title">
          <Msg id="editor-exam-detail.exam.doYouHaveConcerns" />
        </p>
        <p>
          <Msg id="editor-exam-detail.exam.tutorialNotes" />
        </p>
      </div>
      <ul className="code-editor-help-section">
        <li className="code-editor-help-section-link">
          <JumpTo
            to={encodeURI(Message.getMessageByKey("editor.link.allSteps"))}
          >
            <Msg id="editor-exam-detail.exam.howToTakeExam" />
          </JumpTo>
        </li>
        {hasQuizChallenge && (
          <li className="code-editor-help-section-link">
            <JumpTo to={encodeURI(Message.getMessageByKey("editor.link.quiz"))}>
              <Msg id="editor-exam-detail.exam.quiz" />
            </JumpTo>
          </li>
        )}
        {hasCodingChallenge && (
          <>
            <li className="code-editor-help-section-link">
              <JumpTo
                to={encodeURI(
                  Message.getMessageByKey("editor.link.coding.web"),
                )}
              >
                <Msg id="editor-exam-detail.exam.algorithm" />
              </JumpTo>
            </li>
            {hasCLIChallenge && (
              <li className="code-editor-help-cli code-editor-help-section-link">
                <small>
                  <CliSupportBadge />
                  <Msg id="editor-exam-detail.exam.canUseCLI" />
                  <JumpTo
                    to={encodeURI(
                      Message.getMessageByKey("editor.link.coding.cli"),
                    )}
                  >
                    <Msg id="editor-exam-detail.exam.howToUseCLI" />
                  </JumpTo>
                </small>
              </li>
            )}
          </>
        )}
        {hasAIChallenge && (
          <li className="code-editor-help-section-link">
            <JumpTo to={encodeURI(Message.getMessageByKey("editor.link.ai"))}>
              <Msg id="editor-exam-detail.exam.AIstyle" />
            </JumpTo>
          </li>
        )}
      </ul>
      {!tutorial && !exam.isExpired() && (
        <div className="code-editor-help-section">
          <JumpTo
            className="code-c-button button is-primary"
            to={encodeURI(Message.getMessageByKey("editor.link.tutorial"))}
          >
            <Msg id="editor-exam-detail.exam.checkOutTutorial" />
          </JumpTo>
        </div>
      )}
    </div>
  );
}
